import { getConfiguration } from "./configuration";
import { loadLanguage } from "./loadLanguage";

export function getStatsUrl(matchId) {
    const conf = getConfiguration(), lang = loadLanguage().toLowerCase();
    return conf.ps.sts.replace('{{lang}}', lang).replace('{{matchid}}', matchId);
}
